const MODULE_ID_MAPPING = {
  "0150010": "crane_switch",
  "0150011": "harting_3a_socket",
  "0150012": "harting_6b_socket",
  "0150013": "industrial_socket_230v",
  "0150014": "industrial_socket_400v_16a",
  "0150015": "industrial_socket_400v_32a",
  "0150016": "ethernet",
  "0150017": "fuse_box_4te",
  "0150018": "fuse_box_6te",
  "0150019": "fuse_box_12te",
  "0150020": "compressed_air_outlet",
  "0150021": "compressed_air_valve",
  "0150022": "compressed_air_supply",
  "0150023": "empty_module",
  "0150024": "empty_module",
  "0150025": "empty_module",
  "0150093": "harting_3a_supply",
  "0150094": "compressed_air_safety_coupling",
  "0150096": "harting_6b_supply",
  "0150108": "harting_3a_supply",
  "0150109": "harting_3a_socket",
  "0150110": "harting_6b_supply",
  "0150111": "harting_6b_socket",
  "0150112": "industrial_socket_230v",
  "0150113": "industrial_socket_400v_16a",
  "0150114": "industrial_socket_400v_32a",
  "0150115": "ethernet",
  "0150116": "fuse_box_4te",
  "0150117": "compressed_air_supply",
  "0150118": "compressed_air_outlet",
  "0150119": "compressed_air_valve",
  "0150120": "empty_module",
  "0150121": "empty_module",
  "0150122": "empty_module",
  "0150312": "cee_socket",
  "0150355": "cable_outlet",
  "0150358": "cable_outlet",
  "0150442": "industrial_socket_230v",
  "0150443": "ethernet",
  "0150444": "compressed_air_outlet",
  "0150445": "compressed_air_supply",
  "0150458": "compressed_air_valve",
  "0150460": "cable_outlet",
  "0150492": "fuse_box_2te",
  "0150507": "fuse_box_6te",
  "0150508": "fuse_box_12te",
}

const SIDE_MAPPING = {
  LEFT: "left",
  FRONT: "front",
  RIGHT: "right",
  REAR: "back"
}

export function convertConfigurationForModelGen(modules, configuration, modulePlacements, emptyModulePlacements) {
  return {
    columnType: {
      "XXS4": "xxs4",
      "XS2": "xs2",
      "S4": "s4",
      "M2+": "m2",
      "L2+": "l2"
    }[configuration.columnType],
    height: configuration.height,
    feedInLocation: { MODULES: "modules", BASEPLATE: "base", HEAD: "headplate" }[configuration.feedInLocation],
    jibCrane: configuration.jibCrane ? {
      material: configuration.jibCrane.craneType == "CARBON" ? "carbon" : "aluminium",
      height: +configuration.jibCrane.height,
      length: +configuration.jibCrane.length,
      side: configuration.jibCrane.placement == "LEFT" ? "left" : "right"
    } : null,
    placements: [...emptyModulePlacements.map(p => ({
      side: SIDE_MAPPING[p.side],
      height: p.gridIndex * 125,
      moduleHeight: p.module.height * 125,
      moduleId: "empty_module"
    })), ...modulePlacements
      .map(p => ({ ...p, module: modules.find(m => m.itemNumber == p.itemNumber) }))
      .filter(p => p.module != null)
      .map(p => ({
        side: SIDE_MAPPING[p.position.side],
        height: p.position.gridIndex * 125,
        moduleHeight: p.module.slotHeight * 125,
        moduleId: MODULE_ID_MAPPING[p.module.itemNumber.replace(/-.+$/g, "")] || "empty_module"
    }))]
  }
}
